import storage from '@/services/storage'
import auth from '@/services/api/auth'

// import config from '@/services/config'

export const MUTATION_TYPES = {
  'SET_LOGIN': 'SET_LOGIN'
}

export const ACTION_TYPES = {
  REQUEST: 'REQUEST',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  MAGIC_LOGIN: 'MAGIC_LOGIN'
}

const state = {
  token: storage.get('token')
}

const getters = {
  isLoggedIn: state => !!state.token,
  authToken: state => state.token
}

const mutations = {
  [MUTATION_TYPES.SET_LOGIN] (state, token) {
    state.token = token

    if (token === null || token === undefined) {
      storage.remove('token')
      return
    }

    //
    storage.set('token', token)
    auth.setToken(token)
  }
}

const actions = {
  // LOGIN
  async [ACTION_TYPES.LOGIN] ({ commit, state }, { username, password }) {
    const response = await auth.login(username, password).catch(e => false)

    // find smarted way to check this, maybe inside auth.login
    let token = null
    if (response && response.status >= 200 && response.status <= 300) {
      token = response.data.token
    }

    // commit to store
    commit(MUTATION_TYPES.SET_LOGIN, token)

    return !!token
  },

  async [ACTION_TYPES.MAGIC_LOGIN] ({commit, state}, { username, password, ...driver }) {
    const response = await auth.login(username, password, driver).catch(e => e.response)

    if (response.status >= 200 && response.status <= 300) {
      commit(MUTATION_TYPES.SET_LOGIN, response.data.token)
    }

    return response
  },

  async [ACTION_TYPES.LOGOUT] ({ commit }) {
    commit(MUTATION_TYPES.SET_LOGIN)
  },

  // REQUEST
  async [ACTION_TYPES.REQUEST] ({ commit, state }, { username, returnUrl }) {
    // console.log('action: request', username, returnUrl)

    return await (
      await auth.request(username, returnUrl)
        .then(res => true)
        .catch(e => false)
    )
  }
}

export const appModule = {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js